import { getFetchHeaders } from '../getFetchHeaders';
import { getFetchResponseData } from '../getFetchResponseData';
import * as labTypes from './types';

export const actionCreators = {
  getLabTimeEntries: (oid, startDate, endDate, { skipPageLoader = false } = {}) => {
    return async (dispatch) => {
      try {
        dispatch({
          type: labTypes.GET_LAB_TIME_ENTRIES,
          oid,
          selectedDays: [startDate, endDate],
          isLoading: !skipPageLoader,
        });
        var headers = await getFetchHeaders();
        var url = `api/v2/TimeTracker/lrsEntries?UserId=${oid}&StartDate=${startDate}&EndDate=${endDate}`;
        const response = await fetch(url, {
          method: 'GET',
          headers: headers,
        });
        const data = await getFetchResponseData(response);
        dispatch({
          type: labTypes.GET_LAB_TIME_ENTRIES_SUCCESS,
          payload: data,
          selectedDays: [startDate, endDate],
        });
      } catch (error) {
        dispatch({
          type: labTypes.GET_LAB_TIME_ENTRIES_ERROR,
          error: error.message,
        });
        throw error;
      }
    };
  },
  upsertLabTimeEntry: (
    userId,
    date,
    hours,
    projectNumber,
    procedureId,
    requestId,
    requestNumber
  ) => {
    const tzOffset = new Date().getTimezoneOffset();

    return async (dispatch) => {
      try {
        var headers = await getFetchHeaders();
        var url = 'api/v2/TimeTracker/lrsEntries/upsert';

        const res = await fetch(url, {
          method: 'POST',
          headers,
          body: JSON.stringify({
            procedureId,
            requestId,
            projectNumber,
            requestNumber,
            date,
            userId,
            hours,
            timezone: tzOffset,
          }),
        });

        const data = await getFetchResponseData(res);

        dispatch({
          type: labTypes.UPSERT_LAB_TIME_ENTRY_SUCCESS,
          payload: data,
        });
      } catch (error) {
        dispatch({
          type: labTypes.UPSERT_LAB_TIME_ENTRY_ERROR,
          error: error.message,
        });
        throw error;
      }
    };
  },
  deleteLabEntryFromBlacklist: (labEntry, userId) => {
    return async (dispatch) => {
      dispatch({
        type: labTypes.ADD_LAB_ENTRY,
        payload: labEntry,
      });

      try {
        const headers = await getFetchHeaders();
        await fetch(`api/v2/TimeTracker/lrsEntries/userTimesheetBlacklist/delete`, {
          method: 'DELETE',
          headers,
          body: JSON.stringify({
            UserId: userId,
            LabRequest: {
              ProcedureIds: labEntry.procedures.map(p => p.procedureId),
              ProjectNumber: labEntry.projectNumber,
              RequestId: labEntry.requestId,
              RequestNumber: labEntry.requestNumber,
            },
          }),
        });

        return;
      } catch (err) {
        return Promise.reject(err);
      }
    };
  },
  addLabEntryToBlacklist: (labEntry, userId) => {
    return async (dispatch) => {
      dispatch({
        type: labTypes.DELETE_LAB_ENTRY,
        payload: labEntry,
      });

      try {
        const headers = await getFetchHeaders();
        await fetch(
          `api/v2/TimeTracker/lrsEntries/userTimesheetBlacklist/add`,
          {
            method: 'POST',
            headers,
            body: JSON.stringify({
              UserId: userId,
              RequestId: labEntry.requestId,
              ProcedureId: labEntry.procedures[0].procedureId,
            }),
          }
        );

        return;
      } catch (err) {
        return Promise.reject(err);
      }
    }
  },
};
